import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FaqSection() {
  const faqs = [{
    q: '¿Y si no funciona?',
    a: 'El sistema está diseñado para actuar sobre tus hormonas. En 2-3 semanas verás mejoras visibles en tu descanso y desinflamación si sigues los pasos.'
  }, {
    q: '¿Necesito suplementos?',
    a: 'No al inicio. El plan se basa en alimentación, entorno y rutinas para que tu cuerpo vuelva a producir sus propias hormonas del sueño de forma natural.'
  }, {
    q: '¿Funciona con sofocos?',
    a: 'Sí, al regular el cortisol y mejorar el entorno de descanso, la intensidad y frecuencia de los sofocos nocturnos se reduce significativamente.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream relative" data-id="element-84">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-85">
        <FadeIn data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-charcoal mb-12" data-id="element-87">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-89">
                <div className={`bg-white rounded-2xl border transition-all duration-300 overflow-hidden
                  ${isOpen ? 'border-terracotta/30 shadow-warm-md' : 'border-cream-dark/50 shadow-sm hover:border-terracotta/20'}`} data-id="element-90">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-91">
                    <span className="font-serif font-bold text-lg text-charcoal pr-4" data-id="element-92">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0
                      ${isOpen ? 'rotate-180' : ''}`} data-id="element-93" />
                  </button>

                  <div className={`px-6 transition-all duration-300 ease-in-out
                    ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`} data-id="element-94">
                    <p className="text-charcoal-light leading-relaxed" data-id="element-95">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}